import React, { useEffect, useState } from "react";
import { getWithTokenAPI } from "../../utils/Api";
import { useParams } from "react-router-dom";

function ProductList() {
  const { id } = useParams(); // seller id from URL
  const [productList, setProductList] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const token = localStorage.getItem("token");

  useEffect(() => {
    if (!token) return;

    setLoading(true);
    setError(null);

    getWithTokenAPI(token, "/product/find-all")
      .then((res) => {
        console.log("API Full Response:", res);
        const products = res?.data?.data?.Product || [];
        console.log("Total Products Fetched:", products.length);
        console.log("Seller ID from URL:", id);

        // Filter products by seller_id
        const filtered = products.filter((item) => {
          const productSellerId = item?.seller_id?._id;
          console.log("Comparing Product Seller ID:", productSellerId, "with", id);
          return String(productSellerId) === String(id);
        });

        console.log("Filtered Products:", filtered);
        setProductList(filtered);
      })
      .catch((err) => {
        console.error("Error fetching products:", err);
        setError("Failed to fetch products");
      })
      .finally(() => setLoading(false));
  }, [id, token]);

  if (!token) {
    return <p>Please login to view products.</p>;
  }

  if (loading) {
    return <p>Loading products...</p>;
  }

  if (error) {
    return <p className="text-danger">{error}</p>;
  }

  return (
    <div className="card p-3 shadow">
      <h5 className="mb-3">Product List</h5>
      <div className="table-responsive">
        <table className="table table-bordered table-hover">
          <thead className="table-light">
            <tr>
              <th>S.No</th>
              <th>Product Name</th>
              <th>Price</th>
              <th>Image</th>
              <th>Status</th>
            </tr>
          </thead>
          <tbody>
            {productList.length === 0 ? (
              <tr>
                <td colSpan="5" className="text-center">
                  No Products Found
                </td>
              </tr>
            ) : (
              productList.map((item, index) => (
                <tr key={item._id}>
                  <td>{index + 1}</td>
                  <td>{item.name}</td>
                  <td>(Ksh){item.discount_price}</td>
                  <td>
                    {item.product_image && item.product_image.length > 0 ? (
                      <img
                        src={item.product_image[0]}
                        alt={item.name}
                        width="60"
                        height="60"
                        style={{ objectFit: "cover" }}
                      />
                    ) : (
                      "No Image"
                    )}
                  </td>
                  <td>{item.status}</td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
}

export default ProductList;
